module.exports = __webpack_public_path__ + "static/img/fish6.4afe0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish6.png
// module id = 0aEO
// module chunks = 0